import { API } from '../../shared/constants/constants';

export const duplicateServiceLog = async (id) => {
  const res = await API.post(`/service/${id}/duplicate`);
  return res.data;
};

export const duplicateMediaInteraction = async (id) => {
  const res = await API.post(`/issue/${id}/duplicate`);
  return res.data;
};

export const duplicateEngagementLog = async (id) => {
  const res = await API.post(`/engagement/${id}/duplicate`);
  return res.data;
};

export const getFlatIssueById = async (id) => {
  return await API.get(`issue/${id}/flat`);
};

export const getFlatServiceById = async (id) => {
  return await API.get(`service/${id}/flat`);
};

export const getFlatEngagementById = async (id) => {
  return await API.get(`engagement/${id}/flat`);
};
